export const DADOS_FICTICIOS = {
  contato: {
    nome: "Cliente de Teste",
    telefone: "11987654321",
  },

  titularPf: {
    cpf: "19100000000",
    rg: "123456789",
    nacionalidade: "Brasileira",
    estadoCivil: "SOLTEIRO",
  },

  titularPj: {
    cnpj: "19131243000197",
    razaoSocial: "Empresa de Teste LTDA",
  },

  instalacao: {
    numeroInstalacao: () => String(Math.floor(10_000_000 + Math.random() * 89_999_999)),
    ultimoConsumo: "350",
    cep: "01310100",
    endereco: "Avenida Paulista",
    numero: "1578",
    complemento: "",
    bairro: "Bela Vista",
    cidade: "São Paulo",
    estado: "São Paulo",
  },
} as const;
